import React, { useState, useEffect } from "react";

export function InputTextArea({ title, value, placeholder = null, onChange, disabled, readOnly = false, style = {} }) {
    const [content, setContent] = useState(value || "");

    // Update local state when value prop changes
    useEffect(() => {
        setContent(value || "");
    }, [value]);

    function handleChange(e) {
        setContent(e.target.value);
        if (onChange) {
            onChange(e.target.value);
        }
    }

    return (
        <div className="edit-text">
            <label>{title}</label>
            <textarea
                value={content}
                readOnly={readOnly}
                className="outline code"
                placeholder={placeholder}
                type="text"
                disabled={disabled}
                onChange={handleChange}
                style={style}
            />
        </div>
    );
}
